import { Grid } from "@mui/material";
import React from "react";
import RepDetailsHeader from "./home/header";
import RepDetailsTabel from "./home/table";

const RepDetails = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <RepDetailsHeader />
      </Grid>
      <Grid item xs={12}>
        <RepDetailsTabel />
      </Grid>
    </Grid>
  );
};

export default RepDetails;
